import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { isTokenValid } from '../../helpers/token';
import { clearStorage } from '../../helpers/localStorage';
import { isAdministratorUser, isMainTcncpUser } from '../../helpers/role';

const AuthorizedRoute = ({ component: Component, ...rest }) => {
  const [authCheckComplete, setAuthCheckComplete] = useState(false);
  const [authCheckPassed, setAuthCheckPassed] = useState(false);
  const location = useLocation();

  useEffect(async () => {
    setAuthCheckPassed(await isTokenValid() && (await isMainTcncpUser() || await isAdministratorUser()));
    setAuthCheckComplete(true);
  }, [location]);

  if (!authCheckComplete) {
    return null;
  }

  if (authCheckPassed) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }

  clearStorage();
  return <Redirect to="/" />;
};

AuthorizedRoute.propTypes = {
  component: PropTypes.func
};

export default AuthorizedRoute;
